<template>
  <div class="container my-5">
    <div class="text-center title-pp font-weight-bold">
      Frequently asked Questions
    </div>
    <div role="tablist">
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-1
            variant="info"
            class="py-3 font-weight-bold"
          >
            1. Do I need to create an account to book tickets?
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-1"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- Yes, you need to create an account by sharing a few details such
              as email id and telephone number. We require it in order to send
              you the booking confirmation and other details including a unique
              QR. This QR code will be scanned at the Cinema hall and you can
              attend the movie show.
              <br />Incase you don’t receive this QR code or booking
              confirmation, please feel free to connect with us at
              support@gogocinema.com and we will get back to you at the
              earliest. -->
              Yes, you need to create an account by sharing a few details such as your email address and telephone number (see our Privacy Policy for the use and disclosure of the data you provide). We require both in order to send you the booking confirmation and other details including a unique QR.  The QR code will be scanned at the theatre so they know you arrived.   If you do not recieve the QR code or booking confirmation, please feel free to Contact us at support@gogocinema.com and we will get back to you ASAP. 																				
																				
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-2
            variant="info"
            class="py-3 font-weight-bold"
          >
            2. What is the difference between Confirmed and
            Private screening?
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-2"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- GoGoCinema is an unique platform which provides Cinema lovers
              different options to book their tickets.
              <br />During the booking of tickets you will come across3 options
              to select the type of screenings ( Private , Confirmed and
              Confirmed ). -->
              GogoCinema is a unique platform that provides movie lovers different options to book their tickets. During the process to book tickets, we give you 3 options to select the type of screening (Private, Confirmed and Confirmed). 																									
              <p class="mt-2">
                <strong>Private Screening:</strong>
                <!-- You book the complete movie
                hall for yourself and enjoy the movie with your friends, family
                and associates. You decide the audience for this movie by
                booking the complete hall during the movie show. -->
                you book the entire theater like a VIP. You chose what, when and with whom you watch it 😉
              </p>
              <!-- <p class="mt-2">
                <strong>Confirmed Screening:</strong>
                In case you want to
                enjoy a movie at the place and time convenient to you without
                booking the whole hall you can create a “Crowdsourced
                screening”. The other movie fans who like the same movie could
                join you during this crowdsourced screening. <br />
                However for a crowdsourced screening to take place, a minimum
                number of tickets have to be sold by a cut-off date which will
                be mentioned. We will try our best to promote the screening
                created by you. <br />
                Incase the tickets booked are less than the minimum number
                required, the show will be cancelled and you will be refunded
                the ticket charges along with the booking fee as per terms and
                conditions.
                You can see your favorite movie featured on GoGoCinema at your favorite theatre and a time convenient for you, but you don't want to book the entire auditorium. No problem. You "Create a Screening" and select "Crowdsourced Screening." Then, let your friends and family know you booked the movie so they can also buy ticekts to join you. However, a miniumum number of tickets have to be purchased by a cut-off date for a Crowdsourced Screening to take place.  We really want you to see the movie so we will try our best to promote the screening created by you. If the minumum number of tickets (let's say 15) is not purchased by the cut-off date, the show will be cancelled and you will be refunded the ticket charges along with the booking fee as per the Terms and Conditions.																				
																				
              </p> -->
              <p class="mt-2">
                <strong>Confirmed Screening:</strong>
                <!-- Incase you like the movie
                and want to watch it. You can create a crowdsourced show ,
                however you will be booking the minimum tickets required and
                therefore the show will be immediately confirmed. The other
                movie fans can also book the remaining tickets for the show and
                enjoy it with you. <br />
                Incase of any further queries please feel free to write to
                us:support@gogocinema.com -->
                your selected movie title and time is guaranteed as long as you meet the minimum required tickets to purchase.
												
              </p>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-3
            variant="info"
            class="py-3 font-weight-bold"
          >
            3. Can I host a Corporate event / Private event with Gogocinema?
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-3"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- Yes, definitely. GoGoCinema offers our users the most convenient
              way to create their own private screeings( both corporate and
              Personal). During the booking of tickets you will always have 3
              options to select the type of screenings ( Private , Confirmed and
              Crowdsourced ). You can select any of the option suitable to you.
              Incase you find that your favourite Movie is not available in the
              list or the location is not convenient for your private screening
              , please do write to us :<br />support@gogocinema.com and we will
              try to help you create a private screening for you. -->
              Yes, definitely. GoGoCinema offers the most convenient way to create a VIP private screening experience for groups, corporations or your own personal event. Just simply select the theatre, movie and showtime and then select the "Private Screening" option. Now, your on your way to an amazing VIP Private Screening for your group, company or for that special occasion such as a birthday party or anniversary. Don't see your favorite movie? Contact us at support@gogocinema.com and we'll get back to you ASAP.  																				
																				
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-4
            variant="info"
            class="py-3 font-weight-bold"
          >
            4. Unconfirmed Bookings Refund and cancellation:
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-4"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <b-card no-body class="mb-3 faq-box">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    v-b-toggle.inner1
                    variant="info"
                    class="py-3 font-weight-bold"
                  >
                    <!-- 4a. What happens when the Crowdsourced show does not sell
                    the minimum tickets by cut-off date as mentioned ? -->
                    4a. What happens to my Confirmed Screening if the minimum number of tickets is not purchased by the cut-off date?																									
                    <span class="float-right plus">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span class="float-right minus">
                      <img
                        src="@/assets/img/svg/minus-icon-black.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="inner1" class="mt-2" visible>
                  <p class="mb-0 p-3">
                    <!-- -However incase the Confirmed show does not have minimum
                    tickets sold by the cut-off date ( which is specified when
                    booking the show) the show is cancelled and you will be
                    informed by GoGoCinema about it. You will be refunded back
                    your ticket booking amount plus the service fee (paid by
                    you) paid by you. -->
                    We will inform you that your screening is cancelled. However, you have the option to confirm the screening by purchasing the number of ticket to confirm it. Or, we will refund the cost of your ticket(s) plus the service fee.  																									
                  </p>
                </b-collapse>
              </b-card>
              <b-card no-body class="mb-3 faq-box">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button
                    block
                    href="#"
                    v-b-toggle.inner2
                    variant="info"
                    class="py-3 font-weight-bold"
                  >
                    <!-- 4b. Can I cancel my booking and request for a refund for a
                    Confirmed screening when it is confirmed? -->
                    4b. Can I cancel my booking and request a refund for a Confirmed Screening after it is confirmed?																									
                    <span class="float-right plus">
                      <img
                        src="@/assets/img/svg/plus-icon.svg"
                        class="img-fluid"
                      />
                    </span>
                    <span class="float-right minus">
                      <img
                        src="@/assets/img/svg/minus-icon-black.svg"
                        class="img-fluid"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse id="inner2" class="mt-2">
                  <p class="mb-0 p-3">
                    <!-- -All the transactions once completed and confirmed are not
                    exchangeable, refundable or cancellation under any
                    circumstances. As a part of the terms and conditions you
                    have agreed to this when booking was confirmed and
                    completed.<br />
                    Incase of any queries please feel free to write to
                    us:support@gogocinema.com -->
                    As part of the Terms and Conditions, you agreed to no refunds or cancellations. However, we love movie lovers and you can Contact us at support@gogocinema.com to let us know why you need to cancel. We'll get back to ASAP. 																									
                  </p>
                </b-collapse>
              </b-card>
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-5
            variant="info"
            class="py-3 font-weight-bold"
          >
            <!-- 5. While booking I made a mistake of selecting an incorrect date /
            time / Movie. How do I amend my booking? -->
            5. I made a mistake during the booking process and selected the wrong date / time / movie?  How do I amend my screening?																									
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-5"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- - Please send an email to support@gogocinema.com<br />
              with your booking ID & your preferred date, time & movie title. We
              will try to amend the booking provided the date / time/ Movie are
              available. -->
              Don't worry. Please send an email to: support@gogocinema.com with the Booking ID and tell us the correct date / time / movie. We will take care of it for you or get back to you with options. 																									
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-6
            variant="info"
            class="py-3 font-weight-bold"
          >
          6. I booked a screening but haven't receive my ticket yet. Is my transaction confirmed?																									
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-6"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- Thank you for booking on GoGoCinema.<br />
              Incase you have booked for the Confirmed screening, you will
              receive communication from GoGoCinemavery soon. <br />
              Alternately you can log into your account and check in My
              Transaction under My Account tab. -->
              Simply log into your account and check in My Transactions under My Account tab. If your tansaction is not there, you can Contact us at: support@gogocinema.com for help.																									
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-7
            variant="info"
            class="py-3 font-weight-bold"
          >
            <!-- 7. We want to explore and check if we can work/ partner with
            GoGoCinema? -->
            7. We love GoGoCinema and want to inquire about partnering with you.																									
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-7"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- - We are happy to know that you like the GoGoCinema platform and
              want to partner with us. <br />
              The best way to reach us is sending an email to
              support@gogocinema.com -->
              We are delighted that you love GoGoCinema. The best way to reach us is to send an email to support@gogocinema.com and tell us what you have in mind. 																									
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-8
            variant="info"
            class="py-3 font-weight-bold"
          >
            <!-- 8. I can't find my favorite movie on the GoGoCinema list, how can I
            get it ? -->
            8. My favorite movie is not on GoGoCinema.com. What do I need to do to see my favorite movie?																									
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-8"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- - We try to get the movies based on choice made by our audience
              and are constantly upgrading the content.<br />
              Please write to us at support@gogocinema.com with the movie you
              want to watch and we will try to get it for you and share updates
              about it. -->
              We have access to thousands of movies and are constantly adding new content to the site. Please Contact us at support@gogocinema.com with the title and we'll see if it's in our library. We'll get back to you if we can get it for you, but you'll need to book a Private Screening. 																									
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-9
            variant="info"
            class="py-3 font-weight-bold"
          >
            <!-- 9. I can't find my answer in this FAQ list, who can I contact to get
            help? -->
            9. I have a question that is not listed in the FAQs. Whom do I contact?																									
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-9"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- -We are sorry. While we try our best to try and answer the queries
              we have not been able to cover all of them.<br />
              Please do write to us at support@gogocinema.com we will reply you
              at the earliest (within 3 working days) -->
              We're always here to help. Simply write to us at support@gogocinema.com with your question. We'll get back to you with the answer. 																									
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-3 faq-box">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button
            block
            href="#"
            v-b-toggle.accordion-10
            variant="info"
            class="py-3 font-weight-bold"
          >
            <!-- 10. Are there any Credit Card Discounts / Movie Gift Vouchers /
            Complimentary Passes / Promotions that is applicable with booking
            via website? -->
            10. Are there any credit card discounts / movie gift vouchers / complimantary tickets / special promotions on GoGoCinema.com?																									
            <span class="float-right plus">
              <img src="@/assets/img/svg/plus-icon.svg" class="img-fluid" />
            </span>
            <span class="float-right minus">
              <img
                src="@/assets/img/svg/minus-icon-black.svg"
                class="img-fluid"
              />
            </span>
          </b-button>
        </b-card-header>
        <b-collapse
          id="accordion-10"
          visible
          accordion="my-accordion"
          role="tabpanel"
        >
          <b-card-body>
            <b-card-text>
              <!-- -Usually as we have number of screenings going, there is a high
              chance that there would be a promotional offer as well. <br />
              Please visit www.gogocinema.com and you may find some exciting
              offers. You will have to register yourself before you can avail
              the benefit of the promotional offers. -->
              We work very closely with the theatre's management to offer movie lovers, like you, special discounts and promotions from time to time. If you are registered, please visit our Offers and Promotions page to see if there are any current offer or promotions. 																									
            </b-card-text>
          </b-card-body>
        </b-collapse>
      </b-card>

      <!-- <b-card no-body class="mb-3 faq-box">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                href="#"
                v-b-toggle.accordion-2
                variant="info"
                class="py-3 font-weight-bold"
              >My local cinema isn’t available on GOGOCINEMA ?</b-button>
            </b-card-header>
            <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</b-card-text>
              </b-card-body>
            </b-collapse>
            </b-card>-->
      <!-- <b-card no-body class="mb-3 faq-box">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button
                block
                href="#"
                v-b-toggle.accordion-3
                variant="info"
                class="py-3 font-weight-bold"
              >The screening I booked a ticket to got cancelled. Where are you hiding my money ?</b-button>
            </b-card-header>
            <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable VHS.</b-card-text>
              </b-card-body>
            </b-collapse>
            </!-->
      <div class="text-center pt-5">
        <p class="font-weight-bold">
          Haven’t found what you were looking for? Contact us at:
        </p>
        <ul class="list-inline">
          <!-- <li class="list-inline-item pr-md-5 pr-0">
                  <img
                    src="@/assets/img/group-contact.png"
                    class="img-fluid mr-1"
                    height="auto"
                    width="25"
                  />
                  <router-link to="tel:1800-876-873">1800-876-873</router-link>
                  </li>-->
          <li class="list-inline-item pl-md-5 pl-0">
            <img
              src="@/assets/img/group-mail.png"
              class="img-fluid mr-1"
              height="auto"
              width="25"
            />
            <a href="mailto:support@gogocinema.com" target="_top"
              >support@gogocinema.com</a
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "faqs",
  directives: {
    // 'dragscroll': dragscroll
  },

  components: {},

  data() {
    return {};
  }
};
</script>
<style scoped>
.faq-box .btn-info {
  color: #000000;
  background-color: #ffffff;
  border-color: white;
}
.faq-box .btn-info:hover {
  color: #000000;
  background-color: #ffffff;
  border-color: white;
}
.faq-box .btn-info:not(:disabled):not(.disabled):active,
.btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  color: #000000;
  background-color: #ffffff;
  border-color: white;
}
.faq-box .btn-info:focus,
.btn-info.focus {
  box-shadow: unset;
}
.faq-box .btn-info:not(:disabled):not(.disabled):active:focus,
.btn-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: unset;
}
.faq-box .card-header {
  background-color: #ffffff;
}
.faq-box .btn-block {
  text-align: left;
}
.faq-box {
  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.25);
  border-radius: 11px;
  border: none;
}
.title-pp {
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/faqs.vue